import { PartyOverviewItemDto } from './partyConfig'
import { DateTime } from 'luxon'

export type CreateDto = {
    fileId: string
    partyId?: string // Party ID is not required when used as a pivot to create a new party.
    role: FilePartyRole | string
    parentId?: string
}

export type MainDto = FilePartyDto & {
    children?: FilePartyDto[]
}

export type FilePartyDto = PartyOverviewItemDto & {
    identificationRequestExternalId?: string
    pivotId: string
    role: FilePartyRole | string
    reference: string
    fileReferenceRequired?: boolean
    fileReference: string
    invoiceReference: string
}

export enum IdentificationRequestStatus {
    Pending = 'PENDING',
    Success = 'SUCCESS',
    Revoked = 'REVOKED',
}

export type IdentificationRequestDto = {
    id: string
    externalId: string
    href: string
    status: IdentificationRequestStatus
    createdAt: DateTime
    scannedAt?: DateTime
}

export enum FilePartyRole {
    Client = 'CLIENT',
    Debtor = 'DEBTOR',
    Other = 'OTHER',
}

export enum FilePartyAction {
    Add = 'ADD_FILE_PARTY',
    Update = 'UPDATE_FILE_PARTY',
    Delete = 'DELETE_FILE_PARTY',
    GetOverview = 'GET_FILE_PARTIES',
    ResetOverview = 'RESET_FILE_PARTIES',
    GetSuggestions = 'GET_PARTY_CHILD_SUGGESTIONS',
    GetChildList = 'GET_PARTY_CHILD_LIST',
    GetRoles = 'GET_ROLES',
}
